import { Suspense, lazy } from "react";
import t from "prop-types";
import { Route, Switch } from "react-router-dom";
import FullScreenLoading from "@app/common/components/FullScreenLoad";

const StudentsPage = lazy(() => import("./containers/students"));

const propTypes = {
  match: t.object,
};

const UsersRoutes = props => (
  <Switch>
    <Route
      exact
      path={`${props.match.path}/:studentId`}
      render={innerProps => (
        <Suspense fallback={<FullScreenLoading />}>
          <StudentsPage {...innerProps} />
        </Suspense>
      )}
    />
  </Switch>
);

UsersRoutes.propTypes = propTypes;

export default UsersRoutes;
